import React from 'react';
import { ShieldCheck, CheckCircle, Download, MonitorSmartphone, Lock } from 'lucide-react';
import { CTAButton } from './CTAButton';
interface PurchaseSectionProps {
  id?: string;
  showFooter?: boolean;
}
export function PurchaseSection({
  id,
  showFooter = false
}: PurchaseSectionProps) {
  return <section id={id} className="py-8 md:py-12 px-4 bg-brand-50" data-id="element-114">
      <div className="max-w-xl mx-auto bg-white rounded-2xl shadow-xl border border-brand-200 overflow-hidden" data-id="element-115">
        {/* Header badge */}
        <div className="bg-brand-500 py-2 text-center" data-id="element-116">
          <h3 className="text-sm md:text-base font-black uppercase tracking-wider text-white" data-id="element-117">
            🔥 OFERTA DE LANZAMIENTO
          </h3>
        </div>

        <div className="p-5 md:p-6 text-center" data-id="element-118">
          <h4 className="text-lg md:text-xl font-black text-slate-900 mb-3 leading-tight" data-id="element-119">
            Manual Académico de Biología
          </h4>

          {/* Price */}
          <div className="mb-4" data-id="element-120">
            <p className="text-gray-400 font-bold line-through text-base" data-id="element-121">
              $79.990 ARS
            </p>
            <p className="text-4xl md:text-5xl font-black text-brand-600 leading-none" data-id="element-122">
              $19.990<span className="text-xl" data-id="element-123"> ARS</span>
            </p>
            <p className="text-xs font-bold text-gray-600 uppercase tracking-wider mt-1" data-id="element-124">
              Pago único • Acceso inmediato
            </p>
          </div>

          {/* Benefits row */}
          <div className="flex flex-wrap justify-center gap-x-3 gap-y-1 mb-4 text-xs font-semibold text-slate-700" data-id="element-125">
            <span className="flex items-center gap-1" data-id="element-126">
              <Download className="text-brand-500" size={14} data-id="element-127" />
              Descarga inmediata
            </span>
            <span className="flex items-center gap-1" data-id="element-128">
              <CheckCircle className="text-brand-500" size={14} data-id="element-129" />
              Acceso de por vida
            </span>
            <span className="flex items-center gap-1" data-id="element-130">
              <MonitorSmartphone className="text-brand-500" size={14} data-id="element-131" />
              Celular y PC
            </span>
          </div>

          <CTAButton isCheckout={true} className="w-full text-base md:text-lg py-3" data-id="element-132" />

          <div className="flex items-center justify-center gap-2 mt-3 text-xs text-gray-500 font-medium" data-id="element-133">
            <Lock size={12} data-id="element-134" /> Pago 100% seguro
            <span className="mx-1" data-id="element-135">•</span>
            <ShieldCheck size={12} className="text-brand-600" data-id="element-136" /> Garantía 7 días
          </div>
        </div>
      </div>

      {showFooter && <div className="text-center mt-8 max-w-2xl mx-auto space-y-3 text-slate-700 font-medium text-base px-2" data-id="element-137">
          <p data-id="element-138">
            <span className="text-red-500 font-bold" data-id="element-139">
              El precio actual es solo por lanzamiento.
            </span>{' '}
            Este sistema seguirá creciendo con nuevos recursos y
            actualizaciones. Y cuando eso pase, el valor del acceso aumentará.
          </p>
          <p className="text-slate-900 font-bold" data-id="element-140">
            Los docentes que ingresen ahora conservan el precio actual y acceso
            completo.
          </p>
        </div>}
    </section>;
}